import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class CommonApiDataServiceService {

  private apiUrl = environment.apiUrl
  constructor(private http: HttpClient, private store: Store) { }


  addStudentToEntities(type: string, id: number, data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}${type}/add-students/${id}`, data);
  }

  getDataByid(type: string, id?: number): Observable<any> {
    return this.http.get(`${this.apiUrl}${type}/${id}`);
  }

  getDepartmentBelongingData(){
    return this.http.get(`${this.apiUrl}departments-with-classes-batches`);
  }




}
